export default __webpack_public_path__ + "images/assets/a0fcf9c87d77751b25ada9719f4f8ded.svg";